import { TEvent } from '@ws/shared/types';

import { EventTrain } from '../EventTrain/EventTrain';

import { TSyncSessionToken, TSyncStateInfo } from './session.types';

// Одно открытие проекта. Владелец — SyncSessionManager: только он создаёт сессии,
// переключает активную и финализирует старую. Сессия несёт токен (projectId +
// generation), промис гидратации `ready`, снимок локальной записи и train (если
// проект sync-enabled/disabled).
export class SyncSession {
  public readonly token: TSyncSessionToken;
  public readonly ready: Promise<void>;

  private _train: EventTrain<TEvent> | null = null;
  private _snapshot: TSyncStateInfo = { kind: 'missing' };
  private _closing = false;

  // isCurrent проверяется у менеджера (ссылочное равенство активной сессии),
  // чтобы сессия не импортировала менеджер (цикл).
  private readonly _isCurrent: () => boolean;
  private _resolveReady!: () => void;

  constructor(token: TSyncSessionToken, isCurrent: () => boolean) {
    this.token = token;
    this._isCurrent = isCurrent;
    this.ready = new Promise<void>((resolve) => {
      this._resolveReady = resolve;
    });
  }

  public isCurrent(): boolean {
    return !this._closing && this._isCurrent();
  }

  public get train(): EventTrain<TEvent> | null {
    return this._train;
  }

  public syncStateSnapshot(): TSyncStateInfo {
    return this._snapshot;
  }

  // --- методы, вызываемые ТОЛЬКО менеджером ---

  // Пометка на закрытие (синхронно на beginSession новой сессии): даже если train
  // ещё гидратируется, он не должен ожить — при появлении сразу уходит в quiesce.
  public markClosing(): void {
    this._closing = true;
    if (this._train) {
      this._train.quiesceMode();
    }
  }

  public isClosing(): boolean {
    return this._closing;
  }

  public applyHydration(snapshot: TSyncStateInfo, train: EventTrain<TEvent> | null): void {
    this._snapshot = snapshot;
    this._train = train;
    // Гонка: сессию закрыли, пока читалась IDB. Train не оживляем — сразу в тишину.
    if (this._closing && this._train) {
      this._train.quiesceMode();
    }
    this._resolveReady();
  }
}
